export const EdgeBadge = (
  <div className="justify-center relative">
    <svg fill="none" height="20" viewBox="0 0 54 20" width="54" xmlns="http://www.w3.org/2000/svg">
      <rect fill="#3F83F8" height="20" rx="4" width="54" />
      <path
        d="M47.3877 16H39L41.6123 4H50L49.5024 6.1949H43.6559L43.105 8.8036H48.8271L48.3473 10.9985H42.6074L42.0032 13.7871H47.8498L47.3877 16Z"
        fill="white"
      />
      <path
        d="M27 10.8C27 6.88696 30.0178 4 34.1183 4C36.6391 4 38.2722 5.33913 39 6.81739L36.6746 7.7913C36.2485 6.83478 35.0769 6.1913 33.7633 6.1913C31.5621 6.1913 29.6272 8.10435 29.6272 10.6435C29.6272 12.4 30.8876 13.8087 32.9645 13.8087C33.9763 13.8087 34.7574 13.4261 35.3609 12.9217L35.6627 11.513H34.4066L33 9.3913H38.6627L37.6331 13.8783C36.4793 15.2174 34.7751 16 32.8225 16C29.5917 16 27 14 27 10.8Z"
        fill="white"
      />
      <path
        d="M16.5418 4H21.0029C23.562 4 26 6.05097 26 9.16342C26 12.3118 23.9424 16 18.5303 16H14L16.5418 4ZM16.9395 13.7511H18.9798C21.7637 13.7511 23.4409 11.7181 23.4409 9.32534C23.4409 7.58021 22.2478 6.24888 20.536 6.24888H18.5303L16.9395 13.7511Z"
        fill="white"
      />
      <path
        d="M11.6252 16H4L6.3748 4H14L13.5477 6.1949H8.23263L7.73183 8.8036H12.9338L12.4976 10.9985H7.27948L6.73021 13.7871H12.0452L11.6252 16Z"
        fill="white"
      />
    </svg>
  </div>
);
